import { render, staticRenderFns } from "./WeChatIcon.vue?vue&type=template&id=6eed1744&scoped=true&"
import script from "./WeChatIcon.vue?vue&type=script&lang=js&"
export * from "./WeChatIcon.vue?vue&type=script&lang=js&"
import style0 from "./WeChatIcon.vue?vue&type=style&index=0&id=6eed1744&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eed1744",
  null
  
)

export default component.exports